import { useExamContext } from "@features/exam/contexts/ExamContext";
import { usePodcasts } from "@features/podcasts/hooks/usePodcasts";
import { useAppStore } from "@hooks/useAppStore";
import type { ProductsSectionItem } from "@memorang/ui/components/HomeApplet/types";
import { useDevice } from "@memorang/ui/useDevice";

export const useFeaturesSection = ({
	isFetchingItemsCount,
	practiceTestSubtitle,
	numPracticeTests,
}: {
	isFetchingItemsCount: boolean;
	practiceTestSubtitle: string;
	numPracticeTests: number;
}) => {
	const {
		currentExamContext: { examName },
	} = useExamContext();
	const { isMobile } = useDevice();

	const { originalPodcasts } = usePodcasts();

	const allowChangeExam = useAppStore((state) => state.exam.allowChangeExam);
	const practiceTestsLabel = useAppStore(
		(state) => state.exam.practiceTest.label,
	);
	const practiceTestEnabled = useAppStore(
		(state) => state.exam.practiceTest.enabled,
	);

	const showPracticeTests =
		numPracticeTests > 0 && isMobile && practiceTestEnabled.mobile;
	const showPodcasts =
		isMobile && !!originalPodcasts && originalPodcasts.length > 0;

	const featuresSectionData = {
		sectionTitle: examName || "Current Exam",
		isEnabled: allowChangeExam && (showPracticeTests || showPodcasts),
		isLoading: isFetchingItemsCount,
		data: [
			...(showPracticeTests
				? [
						{
							title: practiceTestsLabel || "Practice Tests",
							subtitle: practiceTestSubtitle,
							link: "/practice-tests",
							icon: "clipboard-check-outline",
						},
					]
				: []),
			...(showPodcasts
				? [
						{
							title: "Listen to podcasts",
							subtitle: `${originalPodcasts.length} podcasts`,
							link: "/podcasts",
							icon: "book-open-page-variant-outline",
						},
					]
				: []),
		] as ProductsSectionItem[],
	};

	return featuresSectionData;
};
